module.exports = __webpack_public_path__ + "img/playgrounds-in-motion-logo.0c58815.png";